// extracted by mini-css-extract-plugin
export default {"workSpace":"WorkSpace_workSpace__BMrDC"};